import React, { useState } from "react";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useOrder } from "../context/OrderContext";
import { useStepNavigate } from "../hooks/useStepNavigate";

const Diviziok = () => {
    const navigate = useStepNavigate();
    const { order, updateOrder } = useOrder();
    const divitems = order.divitems || [];
    const [selectedDivitem, setSelectedDivitem] = React.useState(order.divitem_selected || null);

    const handleDivizioSelect = (item) => {
        setSelectedDivitem(item.divitem_szam);
        updateOrder({
            ...order,
            divitem_selected: item.divitem_szam
        });
    };

    return (
        <TablerLayout title="Divizió kiválasztása">
            <div className="row justify-content-center">
                <div className="col-md-10 mb-4">
                    <div className="card-body">
                        {divitems.length === 0 ? (
                            <div className="alert alert-info">
                                Nincsenek megjeleníthető diviziók!
                            </div>
                        ) : (
                            <div className="d-flex flex-column gap-3">
                                {divitems.map((item, index) => (
                                    <button
                                        key={index}
                                        className={`btn ${selectedDivitem === item.divitem_szam ? 'btn-primary' : 'btn-outline-primary'} p-3 text-start d-flex justify-content-between align-items-center`}
                                        onClick={() => handleDivizioSelect(item)}
                                        style={{ 
                                            minHeight: '60px',
                                            fontSize: '1.1rem'
                                        }}
                                    >
                                        <span>{item.divitem_name}</span>
                                        <span className="badge bg-light text-dark fs-6">
                                            {item.divitem_value}
                                        </span>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="d-flex justify-content-between mt-4">
                        <StepperNavButton
                            side="left"
                            label="Vissza"
                            onClick={() => navigate("/FelolvasoTabla")}
                        />
                        <StepperNavButton
                            side="right"
                            label="Tovább"
                            onClick={() => {
                                navigate("/Alairas");
                            }}
                            disabled={!selectedDivitem}
                        />
                    </div>
                </div>
            </div>
        </TablerLayout>
    );
};

export default Diviziok;
